/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { PlatformConfiguration } from './platform-configuration.service';
import { TouchplanPlatform } from './touchplan-platforms.enum';

@Injectable()
export class PlatformDesktopConfiguration extends PlatformConfiguration {
	public readonly platform: TouchplanPlatform = TouchplanPlatform.Desktop;
	public readonly refreshNowNagPath: string = 'versionOfWebsite';
}
